var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"text-primary",attrs:{"to":_vm.url}},[_vm._v(" "+_vm._s(`${_vm.number}/${_vm.params.data.number.code}-AST/${_vm.params.data.number.month}/${_vm.params.data.number.year}`)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }